import React, { forwardRef } from "react";

function AuthChallenger(props, ref) {
  return (
    <>
      <div
        id="challenge-container-background"
        className="challenge-container-background"
      >
        <div
          className="challenge-container"
          style={{ width: `${props.data.dimensions.width}`, height: `${props.data.dimensions.height}` }}
        >
          <iframe
            id="challenge-iframe"
            name="step-up-iframe"
            style={{ border: "0px", background: "#fff" }}
            width={props.data.dimensions.width} height={props.data.dimensions.height}
          />
          <form id="step-up-form" target="step-up-iframe" method="POST" action={props.data.deviceDataCollectionUrl} ref={ref}>
            <input id="JWT_stepup" type="hidden" name="JWT" value={props.data.accessToken}/>
          </form>
        </div>
      </div>
    </>
  );
}

export default forwardRef(AuthChallenger);
